export default "__VITE_ASSET__yb1HD0ab__"